import { ReactNode, CSSProperties } from "react";
import { C } from "./designTokens";

interface TextProps {
  children: ReactNode;
  light?: boolean;
  size?: "sm" | "base" | "lg";
  style?: CSSProperties;
}

export default function Text({ children, light = false, size = "base", style = {} }: TextProps) {
  const sizes: Record<string, CSSProperties> = {
    sm: { fontSize: "0.875rem", lineHeight: 1.7 },
    base: { fontSize: "1rem", lineHeight: 1.7 },
    lg: { fontSize: "1.125rem", lineHeight: 1.6 },
  };

  return (
    <p
      style={{
        fontFamily: C.font,
        color: light ? C.gray300 : C.gray500,
        margin: 0,
        ...sizes[size],
        ...style,
      }}
    >
      {children}
    </p>
  );
}
